import React from 'react'

const Cambiarclave = () => {
  return (
    <div>Cambiarclave</div>
  )
}

export default Cambiarclave